module.exports = __webpack_public_path__ + "static/media/bakery_image1.79df3b92.png";